import gql from 'graphql-tag';

export const ACCOUNT_MANAGERS_QUERY = gql`
  query AccountManagersQuery($first: Int, $after: String, $search: String) {
    accountManagers(first: $first, after: $after, search: $search) {
      edges {
        node {
          id
          email
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
`;
